import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: localStorage.getItem('authToken') || null,
  },
  reducers: {
    setAuthToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('authToken', action.payload);
    },
    clearAuthToken: (state) => {
      state.token = null;
      localStorage.setItem('authToken', null);
      localStorage.removeItem('authToken');
    },
  },
});

export const { setAuthToken, clearAuthToken } = authSlice.actions;

export const selectAuthToken = (state) => state.auth.token;

export default authSlice.reducer;